// removed by extract-text-webpack-plugin
module.exports = {"buttonWrapper":"QCiWDWJbNRR2fFbma5Sjx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TransferStateDescriptionModal/styles.css
// module id = 2941
// module chunks = 0